const AppRoutes = [{
    path: "/",
    component: () => import("@/components/AppLoginPage/AppLoginPage"),
    meta: {
        title: "用户登录"
    }
}, {
    path: "/main",
    component: () => import("@/components/MainPanel/MainPanel"),
    meta: {
        title: "桥梁云端监测平台"
    }
}, {
    path: "/devices",
    component: () => import("@/components/projectDevices/ProjectDevices"),
    meta: {
        title: "设备管理"
    }
}, {
    path: "/alerts",
    component: () => import("@/components/warnInfoPage/WarnInfoPage"),
    meta: {
        title: "告警信息"
    }
}, {
    path: "/user",
    component: () => import("@/components/UserInfoPage/UserInfoPage"),
    meta: {
        title: "用户信息"
    }
}, {
    path: "/members",
    component: () => import("@/components/ProjectMembers/ProjectMembers"),
    meta: {
        title: "项目成员"
    }
}, {
    path: "/documents",
    component: () => import("@/components/ProjectFiles/ProjectFilesPage"),
    meta: {
        title: "项目文档"
    }
}, {
    path: "/dataAnalysis",
    component: () => import("@/components/DataAnalysis/DataAnalysisPage"),
    meta: { title: "数据分析" },
    children: [{
        path: "correlation",
        component: () => import("@/components/DataAnalysis/CorrelationAnalysis"),
        meta: { title: "相关分析" }
    }]
}, {
    path: "/createProject",
    component: () => import("@/components/CreateProjectPage/CreateProjectPage"),
    meta: {
        title: "创建项目"
    }
}]

export default AppRoutes